import React from 'react';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';
import { stateOptions } from 'src/components/enterprise/components/StateControl/stateOptions';
import { CookbookClientSelectSearchWrapper } from 'src/components/CookbookClientSelectSearchWrapper/CookbookClientSelectSearchWrapper';

export interface StateControlProps {
  name: string;
  id: string;
  label?: string;
  rules?: RegisterOptions;
}

export function StateControl({
  name,
  id,
  label = 'State',
  rules = {},
}: StateControlProps): JSX.Element {
  const { control, errors } = useFormContext();

  return (
    <CookbookClientSelectSearchWrapper
      label={label}
      name={name}
      id={id}
      options={stateOptions}
      error={errors[name]}
      control={control}
      blockWidth
      rules={rules}
    />
  );
}
